// extracted by mini-css-extract-plugin
export default {"container":"view-category_container__OLQu+"};